import 'reflect-metadata';

export const Type = (type: any) => {
  return (target: any, propertyKey: string) => {
    Reflect.defineMetadata('design:type', type, target, propertyKey);
  };
};
